import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthorizedRoutingModule } from './authorized-routing.module';
import { AuthorizedComponent } from './components/authorized/authorized.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ImageModule } from '../components/image/image.module';
import { MatListModule } from '@angular/material/list';
import { ToolbarComponent } from '../components/toolbar/toolbar.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AvatarModule } from '../components/avatar/avatar.module';


@NgModule({
  declarations: [
    AuthorizedComponent,
    ToolbarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,
    AvatarModule,
    MatToolbarModule,
    MatMenuModule,
    ImageModule,
    MatListModule,
    MatSidenavModule,
    AuthorizedRoutingModule
  ]
})
export class AuthorizedModule { }
